import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import { Nullable } from "src/services/utils"

export interface ParticipantOutcomeState {
  credentialDoc1: any,
  credentialDoc1FileName: string | null,
  credentialDoc1FileExt: string | null,
  credentialDoc2: any
  credentialDoc2FileName: string | null,
  credentialDoc2FileExt: string | null,
  pk: string | null
  dateCredentialAttained: Nullable<Date>,
  // measurableSkillGain: Nullable<string>,
  // dateSkillAttained: Nullable<Date>,
  dateCredentialAttained1: Nullable<Date>,
  dateCredentialAttained2: Nullable<Date>,
  credentialType: Nullable<string>,
  credentialType2: Nullable<string>,
  credential1: Nullable<string>,
  credential2: Nullable<string>,
  existing_dateCredentialAttained1: Nullable<Date>,
  existing_dateCredentialAttained2: Nullable<Date>,
  existing_credentialType: Nullable<string>,
  existing_credentialType2: Nullable<string>,
  existing_credential1: Nullable<string>,
  existing_credential2: Nullable<string>,
  siteCode: Nullable<string>,
  credentialDoc1Uploaded: number,
  credentialDoc2Uploaded: number,
  credential1Error: Nullable<string>,
  credential2Error: Nullable<string>,
  credentialLink1: Nullable<string>,
  credentialLink2: Nullable<string>,
  external_id: Nullable<string>,
  employers: any,
  incumbentEmployer: Nullable<string>,
  exsiting_incumbentEmployer: Nullable<string>,
  jobPlacementEmployer: Nullable<string>,
  existing_jobPlacementEmployer: Nullable<string>,
  internshipEmployer: Nullable<string>,
  existing_internshipEmployer: Nullable<string>,
  selectedEmployerId: Nullable<number>
}

export const initialState: ParticipantOutcomeState = {
  pk:null,
  credentialDoc1:null,
  credentialDoc1FileName:null,
  credentialDoc1FileExt:null,
  credentialDoc2:null,
  credentialDoc2FileName:null,
  credentialDoc2FileExt:null,
  dateCredentialAttained:null,
  // measurableSkillGain: null,
  // dateSkillAttained:null,
  credential1:null,
  credential2:null,
  credentialType:'No recognized credential',
  credentialType2:'No recognized credential',
  dateCredentialAttained1:null,
  dateCredentialAttained2:null,
  siteCode:null,
  credentialDoc1Uploaded: 0,
  credentialDoc2Uploaded: 0,
  credential1Error:null,
  credential2Error:null,
  credentialLink1:'',
  credentialLink2:'',
  external_id:null,
  existing_credential1:null,
  existing_credential2:null,
  existing_credentialType:'No recognized credential',
  existing_credentialType2:'No recognized credential',
  existing_dateCredentialAttained1:null,
  existing_dateCredentialAttained2:null,
  employers:[],
  incumbentEmployer:null,
  exsiting_incumbentEmployer:null,
  jobPlacementEmployer:null,
  existing_jobPlacementEmployer:null,
  internshipEmployer:null,
  existing_internshipEmployer:null,
  selectedEmployerId: null
}

export const participantOutcomeSlice = createSlice({
  name: "participantOutcome",
  initialState,
  reducers: {
    updateCredentialDoc: (state, action:PayloadAction<any> )=>{
      state.credentialDoc1 = action.payload
    },
    setPK: (state, action:PayloadAction<any>)=>{
      state.pk = action.payload
    },
    updateDateCredentailAttained:(state,action:PayloadAction<any>)=>{
      state.dateCredentialAttained = action.payload
    },
    genericAction:(state,action:PayloadAction<any>)=>{
      try{
        Object.keys(action.payload).forEach((key)=>{
          state[key] = action.payload[key]
        })
      }
      catch(e: any){
        console.error(`Error in genericAction ${e.message}`)
      }
    },
    resetState: (state)=>{
      const pk = state.pk
      const employers = state.employers
      try{
        Object.keys(initialState).forEach((key)=>{
          state[key] = initialState[key]
        })
        state.pk = pk
        state.employers = employers
      }
      catch(e:any){
        console.error(`Error in resetState ${e.message}`)
      }
    }
  }
})

export default participantOutcomeSlice.reducer

export const  {updateCredentialDoc, setPK, updateDateCredentailAttained, genericAction, resetState} = participantOutcomeSlice.actions
